const action = {
    sign_in: 'Zaloguj się',
    continue: 'Kontynuuj',
    continue_as: 'Kontynuuj jako {{name}}',
    create_account: 'Utwórz konto',
    create_account_without_linking: 'Zamiast tego utwórz nowy',
    create: 'Utwórz',
    enter_passcode: 'Wprowadź kod weryfikacyjny',
    confirm: 'Potwierdź',
    cancel: 'Anuluj',
    save_password: 'Zapisz hasło',
    bind: 'Połącz z {{address}}',
    bind_and_continue: 'Połącz i kontynuuj',
    back: 'Wróć',
    nav_back: 'Wstecz',
    nav_skip: 'Pomiń',
    agree: 'Zgadzam się',
    got_it: 'Zrozumiałem',
    sign_in_with: 'Kontynuuj z {{name}}',
    forgot_password: 'Zapomniałeś hasła?',
    switch_to: 'Przełącz na {{method}}',
    sign_in_via_passcode: 'Zaloguj się za pomocą kodu weryfikacyjnego',
    sign_in_via_password: 'Zaloguj się za pomocą hasła',
    change: 'Zmień {{method}}',
    link_another_email: 'Połącz inne konto email',
    link_another_phone: 'Połącz inne konto telefoniczne',
    link_another_email_or_phone: 'Połącz inne konto email lub telefoniczne',
    show_password: 'Pokaż hasło',
    copy: 'Kopiuj',
    verify_via_passkey: 'Weryfikacja za pomocą klucza dostępu',
    download: 'Pobierz',
    remove: 'Usuń',
    edit: 'Edytuj',
    save: 'Zapisz',
    single_sign_on: 'Pojedyncze logowanie',
    authorize: 'Autoryzuj',
    use_another_account: 'Użyj innego konta',
    back_to_current_account: 'Powróć do bieżącego konta',
};
export default Object.freeze(action);
